import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Tooltip from "@mui/material/Tooltip";
import AlertIcon from "@mui/icons-material/Warning";
import IconButton from "@mui/material/IconButton";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ToastContainer, toast } from "react-toastify";
import {  
  add_new_mahila_sabha_member,
  get_mahila_sabha_members_data,
  disable_mahila_bal_sabha_member,
  delete_mahila_bal_sabha_member,
  update_mahila_bal_sabha_member,
} from "../../api/User";
import "../Admin/table.css"

const MahilaSabha = ({ committeName, memberType }) => {
  const [errors, setErrors] = useState({});
  const userId = sessionStorage.getItem("user_id");
  const role_id = sessionStorage.getItem("role_id");
  const gpID = sessionStorage.getItem("gp_data") || "";
  const [formData, setFormData] = useState({
    id: userId,
    committee_type: "",
    member_type: "",
    member_name: "",
    mobile_no: "",
  });
  const [formErrors, setFormErrors] = useState({
    committee_type: "",
    member_type: "",
    member_name: "",
    mobile_no: "",
  });

  const [filteredData, setFilteredData] = useState([]);
  const [token, setToken] = useState(sessionStorage.getItem("token") || "");
  //   const [committeName, setCommitteName] = useState(committeName || "");
  const [othersInput, setOthersInput] = useState(false);
  const [memberTypeState, setMemberTypeState] = useState(memberType || []);
  const [openDialog, setOpenDialog] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [editData, setEditData] = useState(null);
  const [MemberTypeErr, setMemberTypeErr] = useState("");
  const [validateFormData, setvalidateFormData] = useState("");


  const navigate = useNavigate();

  const fetchData = async () => {
    const data = {
      id: userId,
    };
    try {
      const res = await get_mahila_sabha_members_data(token, data);
      if (res.status === "success") {
        setFilteredData(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.", { autoClose: 1000 });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);



  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validate mobile number
    const mobileNoError = validateMobileNo(formData.mobile_no);

    // Set form errors
    setFormErrors({
      committee_type: formData.committee_type ? "" : "Committee Name is required.",
      member_type: formData.member_type ? "" : "Member Type is required.",
      member_name: formData.member_name ? "" : "Member Name is required.",
      mobile_no: mobileNoError,
    });

    // Check if all required fields are valid
    if (
      formData.committee_type &&
      formData.member_type && // Ensure member type is selected
      !mobileNoError && // Ensure mobile number is valid
      formData.member_name
    ) {
      try {
        const res = await add_new_mahila_sabha_member(token, formData);
        if (res.status === "success") {
          toast.success(res.message);
          fetchData();
          handleReset();
          setOthersInput(false); // Hide the "Committees Name" input field
        } else {
          toast.error(res.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("An error occurred while submitting the form.");
      }
    }
  };





  const handleEditSubmit = async (event) => {
    event.preventDefault();

    const errors = {
      committee_type: editData.committee_type ? "" : "Committee Name is required.",
      member_type: editData.member_type ? "" : "Member Type is required.",
      member_name: editData.member_name ? "" : "Member Name is required.",
      mobile_no: validateMobileNo(editData.mobile_no),
    };
    setErrors(errors);

    const hasErrors = Object.values(errors).some((error) => error !== "");
    if (hasErrors) {
      return;
    }

    try {
      const res = await update_mahila_bal_sabha_member(token, editData);
      if (res.status === "success") {
        toast.success(res.message);
        fetchData();  // Refresh data after successful edit
        setOpenEditModal(false);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.error("Error updating record:", error);
      toast.error("An error occurred while updating the record.");
    }
  };


  //validations
  const validateMobileNo = (mobile_no) => {
    if (!mobile_no) return "Mobile Number is required.";

    if (!/^\d{10}$/.test(mobile_no)) return "Mobile Number must be exactly 10 digits.";

    if (mobile_no[0] === '0') return "Mobile Number cannot start with zero.";

    if (/^0{10}$/.test(mobile_no)) return "Mobile Number cannot be all zeros.";

    return "";
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "mobile_no") {
      const numericValue = value.replace(/\D/g, '').slice(0, 10);
      setFormData((prevState) => ({
        ...prevState,
        [name]: numericValue,
      }));

      setFormErrors((prevState) => ({
        ...prevState,
        [name]: validateMobileNo(numericValue),
      }));
    } else if (name === "member_name") {
      const uppercaseValue = value.toUpperCase();
      const cleanedValue = uppercaseValue.replace(/[^A-Z\s]/g, ''); // Allow only uppercase letters and spaces

      setFormData((prevState) => ({
        ...prevState,
        [name]: cleanedValue,
      }));

      setFormErrors((prevState) => ({
        ...prevState,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }

    if (name === "committee_type") {
      setOthersInput(value === "Any other Committee");
    }
  };

  const handleEdit = (index) => {
    const selectedData = filteredData[index];
    setEditData(selectedData);
    setOthersInput(selectedData.committee_type === "Any other Committee");
    setOpenEditModal(true);
  };


  const handleEditChange = (event) => {
    const { name, value } = event.target;
    const updatedValue =
      name === "mobile_no"
        ? value.replace(/\D/g, "").slice(0, 10)
        : name === "member_name"
          ? value.toUpperCase().replace(/[^A-Z\s]/g, "")
          : value;

    setEditData((prevState) => ({
      ...prevState,
      [name]: updatedValue,
    }));

    // Update othersInput when committee_type changes
    if (name === "committee_type") {
      setOthersInput(value === "Any other Committee");
    }

    setErrors((prevState) => ({
      ...prevState,
      [name]: name === "mobile_no" ? validateMobileNo(updatedValue) : "",
    }));
  };


  const handleDisableButton = async (is_active, ID) => {
    console.log(is_active, ID);
    if (is_active == 0) {
      is_active = 1;
    } else if (is_active == 1) {
      is_active = 0;
    }
    const data = {
      id: ID,
      is_active: is_active,
    };
    const res = await disable_mahila_bal_sabha_member(token, data);
    if (res.status == "success") {
      toast.success("Updated successfully", { autoClose: 1000 });
      window.location.reload();
    } else {
      toast.error("An error occurred while updating the item.", { autoClose: 1000 });
    }
  };


  const handleReset = () => {
    setFormData({
      id: userId,
      committee_type: "",
      committeName: "",
      member_type: "",
      member_name: "",
      mobile_no: "",
    });
    setFormErrors({
      committee_type: "",
      member_type: "",
      member_name: "",
      mobile_no: "",
    });
  };


  const handleDelete = (index) => {
    setDeleteIndex(index);
    setOpenDialog(true);
  };

  const handleConfirmDelete = async () => {
    if (deleteIndex !== null) {
      try {
        const idToDelete = filteredData[deleteIndex].id;
        await delete_mahila_bal_sabha_member(token, idToDelete);
        setFilteredData(filteredData.filter((_, i) => i !== deleteIndex));
        toast.success("Deleted successfully");
      } catch (error) {
        console.error("Error deleting item:", error);
        toast.error("An error occurred while deleting the item.");
      }
    }
    setOpenDialog(false);
  };

  const handleToggleActive = async (index) => {
    const updatedData = filteredData.map((row, i) =>
      i === index ? { ...row, is_active: row.is_active === 1 ? 0 : 1 } : row
    );
    setFilteredData(updatedData);

    try {
      const res = await disable_mahila_bal_sabha_member(token, { id: filteredData[index].id, is_active: updatedData[index].is_active });
      if (res.status === "success") {
        toast.success("Updated successfully");
      } else {
        toast.error("An error occurred while updating the item.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("An error occurred while updating the item.");
    }
  };



  const handleCancelDelete = () => {
    setOpenDialog(false);

  };



  const handleComitteeChange = (e) => {
    console.log(e.target.value);
    formData.committee_type = e.target.value
  };


  //   const handleDisableButton = async (is_active, ID) => {
  //     if (!is_active) {
  //       try {
  //         const response = await disableWpftDetails(token, ID);
  //         if (response && response.status === "success") {
  //           toast.success(response.message);
  //           // fetchData();
  //         } else {
  //           toast.error("Failed to disable.");
  //         }
  //       } catch (error) {
  //         console.error("Error disabling:", error);
  //         toast.error("An error occurred while disabling.");
  //       }
  //     }
  //   };

  return (
    <div className="container-fluid" style={{ height: "91vh" }}>
      <h2 className="pt-10" style={{ top: "0", left: "0", margin: "16px",fontWeight:"bold"}}>
      Mahila Sabha
      </h2>
      <form className="row g-3 p-3" onSubmit={handleSubmit}>
        <div className="col-md-4">
          <label htmlFor="committee_type" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
            Committees Name <span style={{ color: "red" }}>*</span>
          </label>
          <select
            className={`form-select ${formErrors.committee_type ? "is-invalid" : ""}`}
            name="committee_type"
            id="committee_type"
            value={formData.committee_type}
            onChange={handleChange}
          >
            <option value="" disabled>Select Committee Name</option>
            {committeName?.map((item, index) => (
              <option key={index} value={item}>
                {item}
              </option>
            ))}
          </select>
          {formErrors.committee_type && (
            <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem", fontWeight: "800" }}>
              {formErrors.committee_type}
            </p>
          )}
        </div>
        {othersInput && (
          <div className="col-md-4">
            <label
              htmlFor="committee-type"
              className="form-label"
              style={{ fontSize: "0.9rem", fontWeight: "bold" }}
            >
              Committees Name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              name="committeName"
              className="form-control"
              placeholder="Enter Committee Name"
              onChange={(e) => handleComitteeChange(e)}
            />
          </div>
        )}


        <div className="col-md-4">
          <label htmlFor="member_type" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
            Member Type <span style={{ color: "red", fontWeight: "800" }}>*</span>
          </label>
          <select
            className={`form-select ${formErrors.member_type ? "is-invalid" : ""}`}
            name="member_type"
            id="member_type"
            value={formData.member_type}
            onChange={handleChange}
          >
            <option value="" disabled>Select Member Type</option>
            {memberType?.map((item, index) => (
              <option key={index} value={item}>
                {item}
              </option>
            ))}
          </select>
          {formErrors.member_type && (
            <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
              {formErrors.member_type}
            </p>
          )}
        </div>

        <div className="col-md-4">
          <label
            htmlFor="member_name"
            className="form-label"
            style={{ fontSize: "0.9rem", fontWeight: "bold" }}
          >
            Member Name <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className={`form-control ${formErrors.member_name ? "is-invalid" : ""
              }`}
            name="member_name"
            id="member_name"
            value={formData.member_name}
            onChange={handleChange}
            placeholder="Enter the Member Name"
          />
          {formErrors.member_name && (
            <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
              {formErrors.member_name}
            </p>
          )}
        </div>
        <div className="col-md-4">
          <label
            htmlFor="mobile_no"
            className="form-label"
            style={{ fontSize: "0.9rem", fontWeight: "bold" }}
          >
            Mobile No <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className={`form-control ${formErrors.mobile_no ? "is-invalid" : ""
              }`}
            name="mobile_no"
            id="mobile_no"
            value={formData.mobile_no}
            onChange={handleChange}
            placeholder="Enter the Mobile No"
          />
          {formErrors.mobile_no && (
            <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
              {formErrors.mobile_no}
            </p>
          )}
        </div>
        <div className="d-flex justify-content-end">
          <div className="col-md-2 row mt-2">
            <Button
              variant="contained"
              onClick={handleReset}
              sx={{
                width: "70%",
                backgroundColor: "#323576",
                color: "#ffffff",
                "&:hover": {
                  backgroundColor: "#5E63C7",
                },
              }}
            >
              Reset
            </Button>
          </div>
          <div className="col-md-2 row mt-2">
            <Button
              variant="contained"
              type="submit"
              sx={{
                width: "70%",
                backgroundColor: "#323576",
                color: "#ffffff",
                "&:hover": {
                  backgroundColor: "#5E63C7",
                },
              }}
            >
              Submit
            </Button>
          </div>
        </div>
      </form>

      {/* <div style={{ overflowX: "auto", maxHeight: "70%", marginTop: "20px" }}>
        <h4>Previous Resource List</h4>
        <hr style={{ margin: "20px 0", border: "2px solid #ddd" }} />
        <Table aria-label="simple table">
          <TableHead
            style={{
              position: "sticky",
              top: 0,
              zIndex: 1,
              backgroundColor: "#fff",
            }}
          >
            <TableRow>
              <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                SR NO.
              </TableCell>
              <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                COMMITTEES NAME
              </TableCell>
              <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                MEMBER TYPE
              </TableCell>
              <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                MEMBER NAME
              </TableCell>
              <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                MOBILE NUMBER
              </TableCell>
              <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                ACTION
              </TableCell>
            </TableRow>

          </TableHead>
          <TableBody>
            {filteredData.map((row, index) => (
              <TableRow
                key={row.id}
                style={{
                  backgroundColor: row.is_active == 0 ? " #ffcccc" : "none",
                }}
              >
                <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                  {index + 1}
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                  {row.committee_type}
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                  {row.member_type}
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                  {row.member_name}
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }} align="center" className="custom-class">
                  {row.mobile_no}
                </TableCell>
                <TableCell
                  style={{ whiteSpace: "nowrap", textAlign: "center" }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Tooltip title="Edit" arrow>
                      <Button
                        onClick={() => handleEdit(index)}
                        size="small"
                        sx={{
                          color: "blue",
                          minWidth: "auto",
                          marginRight: "5px",
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </Button>
                    </Tooltip>
                    <Tooltip title="Delete" arrow>
                      <Button
                        onClick={() => handleDelete(index)}
                        size="small"
                        sx={{ color: "red", minWidth: "auto" }}
                      >
                        <DeleteIcon fontSize="small" />
                      </Button>
                    </Tooltip>
                    <Tooltip
                      title={row.active ? "Deactivate" : "Activate"}
                      arrow
                    >
                      <Switch
                        disabled={row.is_active == 0 ? true : false}
                        checked={row.is_active}
                        onChange={() =>
                          handleDisableButton(row.is_active, row.id)
                        }
                        color="default"
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "green",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: "green",
                          },
                          "& .MuiSwitch-track": {
                            backgroundColor: "red",
                          },
                        }}
                      />
                    </Tooltip>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div> */}
      <Dialog
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle style={{  fontWeight: "bold" }}>
          Edit Record
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setOpenEditModal(false)}
            aria-label="close"
            style={{ position: "absolute", right: 15, top: 7 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleEditSubmit}>
            <div className="row g-3">
              <div className="col-md-4">
                <label htmlFor="editCommitteeType" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                  Committees Name <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className={`form-select ${errors.committee_type ? "is-invalid" : ""}`}
                  name="committee_type"
                  id="editCommitteeType"
                  value={editData?.committee_type || ""}
                  onChange={handleEditChange}
                >
                  <option value="" disabled>Select Committee Name</option>
                  {committeName?.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
                {errors.committee_type && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {errors.committee_type}
                  </p>
                )}
              </div>

              {othersInput && (
                <div className="col-md-4">
                  <label
                    htmlFor="editCommitteeName"
                    className="form-label"
                    style={{ fontSize: "0.9rem", fontWeight: "bold" }}
                  >
                    Committees Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="committeName"
                    className={`form-control ${errors.committeName ? "is-invalid" : ""}`}
                    placeholder="Enter Committee Name"
                    value={editData?.committeName || ""}
                    onChange={handleEditChange}
                  />
                  {errors.committeName && (
                    <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                      {errors.committeName}
                    </p>
                  )}
                </div>
              )}

              <div className="col-md-4">
                <label htmlFor="editMemberType" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                  Member Type <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className={`form-select ${errors.member_type ? "is-invalid" : ""}`}
                  name="member_type"
                  id="editMemberType"
                  value={editData?.member_type || ""}
                  onChange={handleEditChange}
                >
                  <option value="" disabled>Select Member Type</option>
                  {memberType?.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
                {errors.member_type && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {errors.member_type}
                  </p>
                )}
              </div>

              <div className="col-md-4">
                <label
                  htmlFor="editMemberName"
                  className="form-label"
                  style={{ fontSize: "0.9rem", fontWeight: "bold" }}
                >
                  Member Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.member_name ? "is-invalid" : ""}`}
                  name="member_name"
                  id="editMemberName"
                  value={editData?.member_name || ""}
                  onChange={handleEditChange}
                  placeholder="Enter the Member Name"
                />
                {errors.member_name && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {errors.member_name}
                  </p>
                )}
              </div>

              <div className="col-md-4">
                <label
                  htmlFor="editMobileNo"
                  className="form-label"
                  style={{ fontSize: "0.9rem", fontWeight: "bold" }}
                >
                  Mobile No <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.mobile_no ? "is-invalid" : ""}`}
                  name="mobile_no"
                  id="editMobileNo"
                  value={editData?.mobile_no || ""}
                  onChange={handleEditChange}
                  placeholder="Enter the Mobile No"
                />
                {errors.mobile_no && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {errors.mobile_no}
                  </p>
                )}
              </div>

              <div className="d-flex justify-content-end mt-3">
                <Button
                  variant="contained"
                  onClick={() => setOpenEditModal(false)}
                  style={{
                    marginRight: "10px",
                    backgroundColor: "#323576",
                    color: "#ffffff",
                    width: "12%",
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  style={{
                    backgroundColor: "#323576",
                    color: "#ffffff",
                    width: "12%",
                  }}
                >
                  Save
                </Button>
              </div>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog open={openDialog} onClose={handleCancelDelete}>
        <DialogTitle>
          <AlertIcon style={{ color: "red", marginRight: "8px" }} />
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          Are you sure you want to delete this record?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            Cancel
          </Button>
          <Button color="secondary" onClick={handleConfirmDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <ToastContainer />
    </div>
  );
};


export default MahilaSabha;
